import styles from "./index.module.less";

/**
 * @param {{
 *  details: detail[],
 *  coupons:[]
 * }} props
 * @returns
 */

export function DetailPopoverContent({ details, coupons = [] }) {
  const discounts = details.filter((d) => d.type === "discount");
  const payList = details.filter((d) => d.skuId);

  return (
    <div className={styles.detailPopover}>
      <div className={styles.title}>付款明细</div>
      {payList.map((item) => (
        <div className={styles.detailItem} key={item.name}>
          <div className={styles.name}>
            <span>{item.name}</span>
            <span className={styles.price}>
              ¥{item.activity?.price || item.price}
            </span>
          </div>
          <div className={styles.desc}>
            <span>
              {(item.expireTime || item.years) && (
                <>
                  {item.years && <span>{item.years}年</span>} 到期时间{" "}
                  {item.expireTime}
                </>
              )}
            </span>
            {!item.years && <span>x{item.number}</span>}
          </div>
        </div>
      ))}
      {discounts.map((discount) => (
        // 折抵信息
        <div className={styles.discount} key={discount.name}>
          <span>{discount.name}</span>
          <span className={styles.price}>-¥{-discount.price}</span>
        </div>
      ))}
      {coupons.map((coupon) => (
        <div className={styles.discount} key={coupon.id}>
          <span>优惠券</span>
          <span className={styles.price}>-¥{coupon.discount}</span>
        </div>
      ))}
    </div>
  );
}
